import React, { useEffect, useState } from "react";
import { IoClose, IoCameraOutline } from "react-icons/io5";
import {
  fetchCameralistingApi,
  fetchCameralistingEventApi,
} from "../../../api/api";
import { useSelector } from "react-redux";

function Cameralist({ setShowCamera, formData, setFormData, camera_name }) {
  const [camera, setCamera] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  // Debounced search effect
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        handleSearch(searchTerm.trim());
      } else {
        setCamera([]);
        setHasSearched(false);
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleSearch = async (term) => {
    setLoading(true);
    try {
      const data = await fetchCameralistingApi(
        1,
        100,
        term,
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        const cameras = data?.data?.data?.data || [];
        setCamera(cameras);
        setHasSearched(true);
      }
    } catch (error) {
      console.error("Error fetching cameras", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (id) => {
    setSelectedCameraId(id);
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div
      className="rightModal addUser"
      style={{
        width: 350,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <h3 className="titleModal p-3 border-bottom d-flex justify-content-between">
        <span>Camera Groups / Camera</span>
        <button
          onClick={() => setShowCamera(false)}
          className="closeBtn border-0 bg-transparent"
        >
          <IoClose size={24} />
        </button>
      </h3>

      {/* Auto-Search Field */}
      <div className="p-3 border-bottom">
        <input
          type="text"
          placeholder="Search by camera or location name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
        />
      </div>

      {/* Results */}
      <div
        className="px-3 py-2 flex-grow-1"
        style={{ overflowY: "auto", paddingBottom: "80px" }}
      >
        {loading && <p>Loading...</p>}

        {!loading && hasSearched && camera.length === 0 && (
          <p className="text-center mt-3">No cameras found.</p>
        )}

        {!loading &&
          camera.map((ele) => {
            const isSelected = selectedCameraId === ele._id;
            const thumbnailPath = ele.thumbnail?.replace(
              "media/images/",
              "attendance_photos/images/"
            );
            return (
              <div
                key={ele._id}
                className={`d-flex align-items-center py-2 border-bottom ${
                  isSelected ? "bg-light" : ""
                }`}
                onClick={() => handleSelect(ele._id)}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  name="selectedCamera"
                  className="form-check-input me-2"
                  checked={isSelected}
                  onChange={() => handleSelect(ele._id)}
                />
                <img
                  src={`https://visionemptrack.greymatterz.com/${ele.thumbnail?.replace(
                    "media/images/",
                    "attendance_photos/images/"
                  )}`}
                  alt={ele.camera_name}
                  style={{
                    width: 40,
                    height: 40,
                    objectFit: "cover",
                    borderRadius: 4,
                    marginRight: 10,
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://visionemptrack.greymatterz.com/attendance_photos/images/ca9feef0-9a1d-4364-94a5-fb79403480e9.png";
                  }}
                />{" "}
                <span>{ele.camera_name}</span>
              </div>
            );
          })}
      </div>

      {/* Footer */}
      <div
        className="mobalBottom border-top p-3 d-flex justify-content-between"
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          zIndex: 10,
        }}
      >
        <button className="transParent3" onClick={() => setShowCamera(false)}>
          Cancel
        </button>
        <button
          className="mainBlue3"
          onClick={() => {
            if (!selectedCameraId) return;

            const selectedCamera = camera.find(
              (cam) => cam._id === selectedCameraId
            );

            if (selectedCamera) {
              setFormData((prev) => ({
                ...prev,
                camera_ids: [
                  {
                    camera_id: selectedCamera._id,
                    rtsp_url: selectedCamera.rtsp_url,
                  },
                ],
                camera_name: selectedCamera?.camera_name,
              }));
            }

            setShowCamera(false);
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Cameralist;
